import { newToolFilterOAuthMcp } from "../oauth.ts";

export const closeMcpResolver = newToolFilterOAuthMcp({
  iconUrl: "https://app.close.com/icon.svg",
  url: "https://mcp.close.com/mcp",
  label: "Close",
});
